:host {
  --form-field-input-width: 240px;
  height: auto;
}

.form-section + .form-subtitle {
  margin-top: calc(var(--spacer) * 2.5);
}

.form-section {
  margin-top: calc(var(--spacer) * 2.5);

  .flex-group {
    display: flex;
    align-items: flex-start;

    gz-form-field:first-of-type {
      min-width: var(--form-field-label-width);
    }

    .company-label {
      width: 283px;
      min-width: var(--form-field-label-width);
      color: var(--chart-300-icon-buttons);
    }
  }
}
